module.exports = __webpack_public_path__ + "static/media/icon-arrow.c5fb57ef.png";